import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Section, CustomField } from "../../types";
import CustomFieldsList from "../CustomFieldsList";
import * as styles from "./styles_vanilla.css";

interface Props {
  section: Section;
  fields: CustomField[];
  onEditField: (field: CustomField) => void;
  onDeleteField: (field: CustomField) => void;
}

const SectionDisplay: React.FC<Props> = ({ section, fields, onEditField, onDeleteField }) => {
  return (
    <div className={styles.sectionContainer}>
      {/* Section Header */}
      <div className={styles.sectionHeader}>
        <Flex justifyContent="space-between" alignItems="center">
          <div>
            <Text variant="strong-lg">{section.name}</Text>
            {section.description && <Text variant="regular-sm">{section.description}</Text>}
          </div>
          <div className={styles.fieldCount}>
            <Text variant="regular-sm">
              {section.fieldCount} {section.fieldCount === 1 ? "field" : "fields"}
            </Text>
          </div>
        </Flex>
      </div>

      {/* Section Fields */}
      <div className={styles.sectionContent}>
        <CustomFieldsList
          fields={fields}
          onEditField={onEditField}
          onDeleteField={onDeleteField}
        />
      </div>
    </div>
  );
};

export default SectionDisplay;
